import StaticPageLayout from "../components/StaticPageLayout";
import { COMPANY_PAGES } from "../data/companyPagesContent";

const JournalPage = () => (
  <StaticPageLayout page={COMPANY_PAGES.journal} testId="journal-page" />
);

export default JournalPage;
